















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Nav extends Vue {
 links: Array<object> = [
   {text: "Clube",
    path: "/clube"},
   {text: "Loja",
    path: "/"},
   {text: "Produtores",
    path: "/produtores"},
   {text: "Ofertas",
    path: "/ofertas"},
   {text: "Eventos",
    path: "/eventos"},
   ]
  
  isMobileActive = false
  toggleNav(): void{
  this.isMobileActive = !this.isMobileActive
  }
}

